import pt from './pt-br';

const languages = {
  pt,
};

export default languages;
